module.exports = __webpack_public_path__ + "img/bohrungen-1.bc0c0469.png";